{
  "panel": {
    "title": "Notes",
    "newNote_title": "New note",
    "search_placeholder": "Search notes…",
    "search_aria": "Search notes",
    "clearSearch_aria": "Clear search",
    "editorPlaceholder": "What's on your mind…",
    "titleInput_placeholder": "No Title",
    "untitled": "Untitled",
    "emptyNote": "Empty note",
    "loadingNotes": "Loading notes…",
    "noNotesYet": "No notes yet. Tap + to create one.",
    "noResults": "No results for \"{{query}}\"",
    "noNotesTagged": "No notes tagged {{tag}}",
    "tagFilterAll": "All",
    "filterByTag_aria": "Filter by tag",
    "templates": "Templates",
    "editorTheme_aria": "Editor theme",
    "themeActive_aria": "{{theme}} theme (active)",
    "theme_aria": "{{theme}} theme",
    "themeName": {
      "dark": "Dark",
      "sepia": "Sepia",
      "light": "Light",
      "forest": "Forest"
    },
    "voice": "Voice",
    "voice_title": "Voice note",
    "voiceUnavailable_title": "Speech unavailable in this browser",
    "openVoiceRecorder_aria": "Open voice note recorder",
    "summarizing_title": "Summarizing…",
    "summarize_title": "Summarize",
    "summarizeNote_aria": "Summarize note",
    "aiCommands_title": "AI commands  Cmd+K",
    "openAiPalette_aria": "Open AI command palette",
    "enterFocusMode_title": "Focus mode  Cmd+Shift+F",
    "exitFocusMode_title": "Exit focus mode  Cmd+Shift+F",
    "enterFocusMode_aria": "Enter focus mode",
    "exitFocusMode_aria": "Exit focus mode",
    "export_title": "Export note",
    "delete_title": "Delete note",
    "delete_aria": "Delete note",
    "moreActions_title": "More actions",
    "wordCount_one": "{{formatted}} word · ~{{minutes}} min read",
    "wordCount_other": "{{formatted}} words · ~{{minutes}} min read",
    "referencedBy_one": "Referenced by {{count}}",
    "referencedBy_other": "Referenced by {{count}}",
    "noMatchingNotes": "No matching notes",
    "mobileTabs_aria": "Notes view",
    "mobileTabNotes": "Notes",
    "mobileTabEditor": "Editor",
    "saveFailed": "Failed to save note: {{message}}",
    "deleteFailed": "Failed to delete note",
    "loadFailed": "Failed to load notes",
    "analyzeFailed": "Failed to analyze note",
    "aiCommandFailed": "AI command failed",
    "unknownError": "Unknown error"
  },
  "paywall": {
    "title": "Notes is part of Rhemn Pro",
    "safariBody": "Unlock synced notes, dictation, and AI summaries with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "body": "Unlock synced notes, browser-based dictation, and structured AI summaries."
  },
  "format": {
    "bold": "Bold",
    "italic": "Italic",
    "strikethrough": "Strikethrough",
    "inlineCode": "Inline code",
    "heading1": "Heading 1",
    "heading2": "Heading 2",
    "heading3": "Heading 3",
    "bulletList": "Bullet list",
    "numberedList": "Numbered list",
    "blockquote": "Blockquote",
    "codeBlock": "Code block",
    "toggleBold_aria": "Toggle bold",
    "toggleItalic_aria": "Toggle italic",
    "toggleStrikethrough_aria": "Toggle strikethrough",
    "toggleInlineCode_aria": "Toggle inline code",
    "toggleBulletList_aria": "Toggle bullet list",
    "toggleNumberedList_aria": "Toggle numbered list",
    "toggleBlockquote_aria": "Toggle blockquote",
    "formatOptions_aria": "Format options"
  },
  "analysis": {
    "heading": "Summary",
    "onDevice": "⚡ On-device",
    "onDevice_aria": "Processed on-device",
    "applyToNote_title": "Apply to note",
    "applyToNote_aria": "Apply summary to note",
    "summaryLabel": "Summary",
    "keyPointsLabel": "Key Points",
    "noKeyPoints": "No key points returned for this note."
  },
  "export": {
    "markdown": "Export as Markdown",
    "plainText": "Export as Plain Text",
    "pdf": "Export as PDF",
    "allZip": "Export all as ZIP",
    "label": "Export"
  },
  "cmdk": {
    "dialog_aria": "AI command palette",
    "input_placeholder": "Ask AI or run a command…",
    "esc": "Esc",
    "back_aria": "Back",
    "translateTo": "Translate to",
    "language_placeholder": "Language…",
    "aiActions": "AI Actions",
    "noCommandsMatch": "No commands match \"{{query}}\"",
    "continue": {
      "label": "Continue writing",
      "description": "Continue from where you left off"
    },
    "summarize": {
      "label": "Summarize selection",
      "description": "Condense to key points"
    },
    "formal": {
      "label": "Make this formal",
      "description": "Elevate tone to professional"
    },
    "simplify": {
      "label": "Simplify",
      "description": "Shorter, clearer language"
    },
    "translate": {
      "label": "Translate to…",
      "description": "Translate to another language"
    },
    "expand": {
      "label": "Expand this bullet",
      "description": "Grow selected bullet into prose"
    },
    "languages": {
      "Spanish": "Spanish",
      "Arabic": "Arabic",
      "French": "French",
      "German": "German",
      "Japanese": "Japanese",
      "Portuguese": "Portuguese"
    }
  },
  "templates": {
    "dialog_aria": "Choose template",
    "header": "Choose a Template",
    "builtInLabel": "Built-in",
    "myTemplatesLabel": "My Templates",
    "saveCurrent": "Save current note as template",
    "myTemplatesEmpty": "Your saved templates will appear here",
    "useTemplate": "Use Template",
    "meeting": {
      "name": "Meeting Notes",
      "description": "Capture decisions and action items",
      "structure": "Attendees / Agenda / Notes / Actions"
    },
    "journal": {
      "name": "Daily Journal",
      "description": "Reflect on your day",
      "structure": "Gratitude / Today's wins / Notes"
    },
    "book": {
      "name": "Book Summary",
      "description": "Capture key ideas from a book",
      "structure": "Core idea / Key quotes / Takeaways"
    },
    "project": {
      "name": "Project Brief",
      "description": "Outline scope, goals, and stakeholders",
      "structure": "Goal / Scope / Risks / Timeline"
    },
    "brainstorm": {
      "name": "Brainstorm",
      "description": "Free-form idea capture",
      "structure": "Topic / Ideas / Next steps"
    },
    "weekly": {
      "name": "Weekly Review",
      "description": "Review and plan your week",
      "structure": "Wins / Struggles / Focus areas"
    }
  },
  "voice": {
    "dialog_aria": "Voice note recorder",
    "cancel_aria": "Cancel",
    "statusRecording": "Recording",
    "statusTranscribing": "Transcribing…",
    "statusReview": "Review",
    "skip": "Skip",
    "mark": "Mark",
    "mark_title": "Drop a timestamp marker",
    "captureMeeting": "Capture meeting",
    "captureMeeting_title": "Also capture audio from a meeting tab",
    "meeting": "Meeting",
    "meeting_title": "Capturing the meeting tab",
    "markers_aria": "Timestamp markers",
    "listening": "Listening…",
    "micDenied": "Microphone access is off. Allow it in Settings, then try again.",
    "captureFailed": "Recording could not start. Try again in a moment.",
    "tabPicker_aria": "Choose a meeting tab to capture",
    "captureFrom": "Capture audio from…",
    "noAudibleTab": "No tab is playing audio. Open your meeting and make sure someone is speaking, then try again.",
    "tabPickerCancel": "Cancel",
    "tabTranscript": "Transcript",
    "structuring": "Structuring…",
    "structuredNote": "Structured Note",
    "structureFailed": "Couldn't create the structured note.",
    "retryStructure": "Try again",
    "browserTranscript": "Browser transcript",
    "nothingCaptured": "Nothing was captured.",
    "buildingStructured": "Building structured note…",
    "cancel": "Cancel",
    "stop": "Stop",
    "recordAgain": "Record again",
    "saveToNote": "Save to Note",
    "statusMeeting": "Meeting",
    "captureStrip_aria": "Capturing audio from {{tab}}",
    "stopCapture": "Stop capture",
    "stopCapture_title": "Stop capturing the tab — your mic keeps recording",
    "stopsIn": "Stops in {{time}}",
    "autoStopped": "Recording stopped at the 60-minute limit.",
    "autoStoppedQuota": "Recording stopped — you've used this month's transcription minutes.",
    "captureLost": "The meeting tab closed. Your mic is still recording.",
    "tabSummary": "Summary",
    "noSpeakers": "Speakers not identified",
    "speakerN": "Speaker {{number}}",
    "renameSpeaker_aria": "Rename {{name}} — applies to all their lines",
    "renameSpeaker_input_aria": "Speaker name",
    "turnTime_title": "Spoken at {{time}}",
    "actionItemsTitle": "Action Items",
    "actionsCount": "{{checked}} of {{total}}",
    "addToTasks_one": "Add {{count}} to Tasks",
    "addToTasks_other": "Add {{count}} to Tasks",
    "addToTasksZero": "Add to Tasks",
    "adding": "Adding…",
    "tasksAdded_one": "{{count}} task added",
    "tasksAdded_other": "{{count}} tasks added",
    "viewTasks": "View",
    "addFailed": "Couldn't add — try again.",
    "minutesLeft_one": "{{count}} min left",
    "minutesLeft_other": "{{count}} min left",
    "minutesLeftShort_one": "{{count}} min left",
    "minutesLeftShort_other": "{{count}} min left",
    "minutesLeft_title": "{{count}} transcription minutes left this month",
    "quotaExhausted": "You've used this month's meeting minutes. They refresh {{date}}.",
    "quotaUnknown": "Minutes left unknown — recording may hit your monthly limit",
    "meetingProRequired": "Meeting transcription is part of Pro. Your live transcript is kept below.",
    "gateTitle": "Meeting recording",
    "gateBody": "Record a meeting tab alongside your mic — with speakers identified and action items extracted. Included with Pro.",
    "gateLater": "Not now",
    "gateCta": "See Pro",
    "roomOption": "No tab — record the room",
    "roomHint": "A call on speaker, a native app, or people in the room — anything you can hear out loud.",
    "roomHint_title": "If the other side is on your headphones, the mic can't hear them — use the speaker.",
    "recordRoom": "Record the room",
    "recordRoom_title": "Record everyone the mic can hear — speakers identified",
    "roomStart": "Start",
    "statusRoom": "Room",
    "roomStrip": "Recording the room",
    "roomStrip_aria": "Recording the room — everyone the microphone hears",
    "roomOff": "Turn off",
    "roomOff_title": "Turn off room mode — this becomes a regular voice note",
    "roomRenameHint": "Tap a name to rename — one of these is you.",
    "gateBodyRoom": "Record what's said around you — with speakers identified and action items extracted. Included with Pro.",
    "roomHintDevice": "Calls on this device can't be recorded — iOS keeps them private. Another phone on speaker, or a conversation in the room, works.",
    "autoStoppedSize": "Recording stopped at the upload size limit.",
    "tooLarge": "The recording was too large to upload, so it couldn't be transcribed.",
    "destTo": "To",
    "dest_aria": "Add to list: {{name}}",
    "destMenu_aria": "Choose a list",
    "destNewPending_aria": "New list: {{name}}"
  },
  "meetingNotice": {
    "title": "Meetings, in your notes",
    "body": "Rhemn can now record a meeting tab you choose — only while you're recording a voice note, and only the tab you pick.",
    "factPrivacy": "Audio is processed to create your transcript, then discarded. Recordings are never stored.",
    "factControl": "Nothing is captured until you press record and choose a tab.",
    "cta": "Got it",
    "privacyLink": "Read our privacy policy",
    "dialog_aria": "About the new meeting recording permission"
  }
}
